import { SUBJECT_LIBRARY_TAB_SLUG } from '@yandex-int/k-common/typings';
import isEqual from 'lodash/isEqual';
import { Tabs } from 'platform-components';
import React, { useCallback, useMemo } from 'react';

import LibraryTabLink from './library__tabs-link';

import './library__tabs-view.scss';

export interface LibraryTabView {
    name: string;
    slug: SUBJECT_LIBRARY_TAB_SLUG;
}

interface Props {
    currentTab: SUBJECT_LIBRARY_TAB_SLUG;
    onTabClick: (slug: SUBJECT_LIBRARY_TAB_SLUG) => void;
    tabs: Array<LibraryTabView>;
}

export const LibraryTabsView = ({ currentTab, onTabClick, tabs }: Props) => {
    const handleClick = useCallback(
        (slug: SUBJECT_LIBRARY_TAB_SLUG, isSelected: boolean) => {
            if (!isSelected) {
                onTabClick(slug);
            }
        },
        [onTabClick]
    );

    const tabsView = useMemo(
        () =>
            tabs.map((tab) => {
                const isSelected = currentTab === tab.slug;

                return (
                    <LibraryTabLink
                        key={tab.slug}
                        onClick={() => handleClick(tab.slug, isSelected)}
                        selected={isSelected}
                        tab={tab}
                    />
                );
            }),
        [currentTab, tabs, handleClick]
    );

    if (tabs.length <= 1) {
        return null;
    }

    return (
        <Tabs mix="library__tabs" withDivider={true}>
            {tabsView}
        </Tabs>
    );
};

export default React.memo(LibraryTabsView, isEqual);
